 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"AccountSettlements~ActionCreate~AgreementCreate~AgreementShow~Bank~Client~CustomerCreate~CustomerEdi~1b7e2263":"AccountSettlements~ActionCreate~AgreementCreate~AgreementShow~Bank~Client~CustomerCreate~CustomerEdi~1b7e2263","AccountSettlements":"AccountSettlements","ActionCreate":"ActionCreate","AgreementCreate":"AgreementCreate","AgreementShow~Bank~Client~CustomerShow":"AgreementShow~Bank~Client~CustomerShow","AgreementShow~CustomerShow~TerminalShow":"AgreementShow~CustomerShow~TerminalShow","AgreementShow~Agreements":"AgreementShow~Agreements","AgreementShow":"AgreementShow","Client~CustomerShow":"Client~CustomerShow","CustomerShow":"CustomerShow","Bank":"Bank","Client~CustomerCreate~CustomerEdit~Transactions":"Client~CustomerCreate~CustomerEdit~Transactions","Client":"Client","TerminalShow":"TerminalShow","CustomerCreate~CustomerEdit":"CustomerCreate~CustomerEdit","CustomerCreate":"CustomerCreate","CustomerEdit":"CustomerEdit","Transactions":"Transactions","Dashboard":"Dashboard","KYC":"KYC","Messages":"Messages","StepListCreate":"StepListCreate","Terminals":"Terminals","Actions":"Actions","AdminLayout":"AdminLayout","AgreementEdit":"AgreementEdit","Agreements":"Agreements","Client404":"Client404","Customers":"Customers","ForgotPassword":"ForgotPassword","Login":"Login","NotFound":"NotFound","ResetPassword":"ResetPassword","StepLists":"StepLists","Support":"Support","TerminalCreate~TerminalEdit":"TerminalCreate~TerminalEdit","TerminalCreate":"TerminalCreate","TerminalEdit":"TerminalEdit","TwoFactor":"TwoFactor","UserCreate":"UserCreate","UserEdit":"UserEdit","Users":"Users"}[chunkId]||chunkId) + "." + {"AccountSettlements~ActionCreate~AgreementCreate~AgreementShow~Bank~Client~CustomerCreate~CustomerEdi~1b7e2263":"ec296077","AccountSettlements":"5dcf2c12","ActionCreate":"892dc224","AgreementCreate":"6faca207","AgreementShow~Bank~Client~CustomerShow":"be0bae00","AgreementShow~CustomerShow~TerminalShow":"703d85d9","AgreementShow~Agreements":"06e26279","AgreementShow":"d0980022","Client~CustomerShow":"7a8bb83c","CustomerShow":"bb41921a","Bank":"0fe0b31d","Client~CustomerCreate~CustomerEdit~Transactions":"611d778a","Client":"5e6bf06f","TerminalShow":"3ea8ae26","CustomerCreate~CustomerEdit":"a733613f","CustomerCreate":"793146d7","CustomerEdit":"3370c372","Transactions":"9cbea72e","Dashboard":"457029ee","KYC":"dadbc79f","Messages":"fc45aedd","StepListCreate":"795c2f4a","Terminals":"5fbc8d9c","Actions":"a1e92206","AdminLayout":"7958eea4","AgreementEdit":"30adba8f","Agreements":"8aa7f981","Client404":"a055614b","Customers":"50a9c8bc","ForgotPassword":"83b0420d","Login":"fe7c7b5f","NotFound":"3004ba55","ResetPassword":"cfa6b68e","StepLists":"90db1937","Support":"a3889036","TerminalCreate~TerminalEdit":"b85282ca","TerminalCreate":"9c09b22d","TerminalEdit":"342679b4","TwoFactor":"71b80dfb","UserCreate":"0d9b9c5f","UserEdit":"cc8ae821","Users":"f3bd0c9f","chunk-2d216214":"cece44c1","chunk-2d216257":"1caeb235","chunk-939cb216":"6e95d4c9"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"AccountSettlements":1,"ActionCreate":1,"AgreementCreate":1,"AgreementShow~CustomerShow~TerminalShow":1,"AgreementShow~Agreements":1,"AgreementShow":1,"Client~CustomerShow":1,"CustomerShow":1,"Bank":1,"Client~CustomerCreate~CustomerEdit~Transactions":1,"Client":1,"TerminalShow":1,"Transactions":1,"Dashboard":1,"KYC":1,"Messages":1,"StepListCreate":1,"Terminals":1,"AdminLayout":1,"AgreementEdit":1,"Agreements":1,"Client404":1,"NotFound":1,"Support":1,"TerminalCreate~TerminalEdit":1,"UserCreate":1,"UserEdit":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"AccountSettlements~ActionCreate~AgreementCreate~AgreementShow~Bank~Client~CustomerCreate~CustomerEdi~1b7e2263":"AccountSettlements~ActionCreate~AgreementCreate~AgreementShow~Bank~Client~CustomerCreate~CustomerEdi~1b7e2263","AccountSettlements":"AccountSettlements","ActionCreate":"ActionCreate","AgreementCreate":"AgreementCreate","AgreementShow~Bank~Client~CustomerShow":"AgreementShow~Bank~Client~CustomerShow","AgreementShow~CustomerShow~TerminalShow":"AgreementShow~CustomerShow~TerminalShow","AgreementShow~Agreements":"AgreementShow~Agreements","AgreementShow":"AgreementShow","Client~CustomerShow":"Client~CustomerShow","CustomerShow":"CustomerShow","Bank":"Bank","Client~CustomerCreate~CustomerEdit~Transactions":"Client~CustomerCreate~CustomerEdit~Transactions","Client":"Client","TerminalShow":"TerminalShow","CustomerCreate~CustomerEdit":"CustomerCreate~CustomerEdit","CustomerCreate":"CustomerCreate","CustomerEdit":"CustomerEdit","Transactions":"Transactions","Dashboard":"Dashboard","KYC":"KYC","Messages":"Messages","StepListCreate":"StepListCreate","Terminals":"Terminals","Actions":"Actions","AdminLayout":"AdminLayout","AgreementEdit":"AgreementEdit","Agreements":"Agreements","Client404":"Client404","Customers":"Customers","ForgotPassword":"ForgotPassword","Login":"Login","NotFound":"NotFound","ResetPassword":"ResetPassword","StepLists":"StepLists","Support":"Support","TerminalCreate~TerminalEdit":"TerminalCreate~TerminalEdit","TerminalCreate":"TerminalCreate","TerminalEdit":"TerminalEdit","TwoFactor":"TwoFactor","UserCreate":"UserCreate","UserEdit":"UserEdit","Users":"Users"}[chunkId]||chunkId) + "." + {"AccountSettlements~ActionCreate~AgreementCreate~AgreementShow~Bank~Client~CustomerCreate~CustomerEdi~1b7e2263":"31d6cfe0","AccountSettlements":"8ba6d01b","ActionCreate":"09adee87","AgreementCreate":"89a95256","AgreementShow~Bank~Client~CustomerShow":"31d6cfe0","AgreementShow~CustomerShow~TerminalShow":"534fb616","AgreementShow~Agreements":"a4bd827f","AgreementShow":"4596ad1c","Client~CustomerShow":"a06d1626","CustomerShow":"ee7157bc","Bank":"c621bd3a","Client~CustomerCreate~CustomerEdit~Transactions":"8ba6d01b","Client":"fbd675c5","TerminalShow":"5a3f399e","CustomerCreate~CustomerEdit":"31d6cfe0","CustomerCreate":"31d6cfe0","CustomerEdit":"31d6cfe0","Transactions":"b94ec780","Dashboard":"e3fae450","KYC":"4a54e9d9","Messages":"d47ee4cf","StepListCreate":"67044843","Terminals":"3d00eaa4","Actions":"31d6cfe0","AdminLayout":"e217fa42","AgreementEdit":"bf5a1eee","Agreements":"d39c8847","Client404":"b9b472a2","Customers":"31d6cfe0","ForgotPassword":"31d6cfe0","Login":"31d6cfe0","NotFound":"e3152d85","ResetPassword":"31d6cfe0","StepLists":"31d6cfe0","Support":"159bf9d3","TerminalCreate~TerminalEdit":"8ba6d01b","TerminalCreate":"31d6cfe0","TerminalEdit":"31d6cfe0","TwoFactor":"31d6cfe0","UserCreate":"8ba6d01b","UserEdit":"8ba6d01b","Users":"31d6cfe0","chunk-2d216214":"31d6cfe0","chunk-2d216257":"31d6cfe0","chunk-939cb216":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
